import React, { useState, useId, forwardRef } from 'react';
import styles from './Input.module.css';
import { classNames } from '../../utils/helpers';
import { EyeIcon, EyeOffIcon } from '../Icons';

const Input = forwardRef(({
  type = 'text',
  label,
  required = false,
  error,
  hint,
  leftIcon,
  rightIcon,
  fullWidth = true,
  disabled = false,
  className,
  containerClassName,
  id,
  ...props
}, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const generatedId = useId();
  const inputId = id || generatedId;
  const isPassword = type === 'password';
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;

  return (
    <div className={classNames(styles.container, fullWidth && styles.fullWidth, containerClassName)}>
      {label && (
        <label className={styles.label} htmlFor={inputId}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}
      <div className={styles.inputWrapper}>
        {leftIcon && <span className={styles.leftIcon}>{leftIcon}</span>}
        <input
          ref={ref}
          id={inputId}
          type={inputType}
          aria-invalid={error ? true : undefined}
          className={classNames(
            styles.input,
            error && styles.error,
            leftIcon && styles.hasLeftIcon,
            (rightIcon || isPassword) && styles.hasRightIcon,
            disabled && styles.disabled,
            className
          )}
          disabled={disabled}
          {...props}
        />
        {isPassword && (
          <button
            type="button"
            className={styles.rightIcon}
            onClick={() => setShowPassword(!showPassword)}
            tabIndex={-1}
          >
            {showPassword ? <EyeOffIcon /> : <EyeIcon />}
          </button>
        )}
        {!isPassword && rightIcon && (
          <span className={styles.rightIcon}>{rightIcon}</span>
        )}
      </div>
      {(error || hint) && (
        <span className={classNames(styles.hint, error && styles.errorText)}>
          {error || hint}
        </span>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
